import * as React from "react";
import {
    UitkIconSize,
    UitkPrimaryButton,
    UitkRadioButtonGroup,
    UitkTextArea,
    UitkIcon,
    UitkRadioButton,
    UitkSpacing,
    UitkToast, 
    UitkHeading
} from "@egencia/uitk-react";
import { useState } from 'react'


export function FaqFeedback({ article, topic, hasUser }) {
    const faqFeedbackTitle = uitk.i18n.msg('faq_feedback_title');
    const faqFeedBackYes = uitk.i18n.msg('faq_feedback_yes');
    const faqFeedBackNo = uitk.i18n.msg('faq_feedback_no');
    const faqFeedbackResponse = uitk.i18n.msg('faq_feedback_response');

    const [disable, setDisable] = useState(false);
    const [radioSelect, setRadioSelect] = useState('');
    const isHomePage = EG.pageName.includes("HelpCenter.Homepage") ? true : false;
    const feedbackButtonClickedPrefix = isHomePage ? 'HelpCenter.Homepage.Feedback.' : 'HelpCenter.Panel.Feedback.';
    
    const defaultTitleForOmniture = article.defaultTitleForEmail.replace(/\?/g, '').split(' ').join('.');

    const [showSurvey, setShowSurvey] = useState(false);
    const [showThankYou, setShowThankYou] = useState(false);
    
    function handleRadioSelectYes() {
        omnitureLog.logClickEvent(`${feedbackButtonClickedPrefix}${defaultTitleForOmniture}.Yes.Clicked`);
        setShowThankYou(true);
        setDisable(true);
        setRadioSelect('yes');
    }
    
    function handleRadioSelectNo() {
        hasUser
            ? setShowSurvey(true)
            : setShowThankYou(true);

        omnitureLog.logClickEvent(feedbackButtonClickedPrefix + defaultTitleForOmniture + '.No.Clicked');
        setDisable(true);
        setRadioSelect('no');
    }
    
    function handleSubmitFeedback() {
        setShowSurvey(false);
        setShowThankYou(true);
    }
    
    return (
        <div>
            <UitkSpacing margin={{blockstart: "four"}}>
                <UitkHeading size={6}>{faqFeedbackTitle}</UitkHeading>
            </UitkSpacing>
            <UitkRadioButtonGroup
                group={`${topic}-${article.id}-helpful`}
                onChange={(e) => {e.target.value === 'yes' ? handleRadioSelectYes() : handleRadioSelectNo()}}
                selected={radioSelect}
            > 
                <UitkRadioButton
                    id={`helpful-yes`}
                    value={'yes'}
                    label={faqFeedBackYes}
                    disabled={disable}
                    checked={radioSelect === 'yes'}
                />
                <UitkRadioButton
                    id={`helpful-no`}
                    value={'no'}
                    label={faqFeedBackNo}
                    disabled={disable}
                    checked={radioSelect === 'no'}
                />
            </UitkRadioButtonGroup>
            <FeedbackSurvey 
                visible={showSurvey} 
                article={article} 
                onSubmit={handleSubmitFeedback} 
                topic={topic}
            />
            <UitkToast
                show={showThankYou}
                onDismiss={() => setShowThankYou(false)}
            >
                <UitkIcon name='done' size={UitkIconSize.XSMALL} />
                { faqFeedbackResponse }
            </UitkToast>
        </div>
    )
}

function FeedbackSurvey({ visible, article, topic, onSubmit }) {
    const faqFeedbackSendButton = uitk.i18n.msg('faq_feedback_send');
    const faqFeedbackLabel = uitk.i18n.msg('faq_feedback_label');
    const faqFeedbackPlaceholder = uitk.i18n.msg('faq_feedback_placeholder');
    const faqFeedbackButtonClicked = 'HelpCenter.Homepage.Feedback.';
    const [message, setMessage] = useState('');
    
    function handleSubmit() {
        // Omniture
        let linkId = faqFeedbackButtonClicked + article.id + '.Send.Clicked';
        let trackVarsAndValue = {"eVar97": message.length};
        let trackVars = 'eVar97';
        omnitureLog.logClickEventWithTrackVars(linkId, trackVarsAndValue, trackVars);
        
        uitk.utils.egenciaFetch('/help-center/sendEmail', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body:  JSON.stringify({
                faq_id: article.id,
                message: message,
            })
        }).catch(e => {
          uitk.logger.error('Failed to send email', e);  
        });
        
        onSubmit();
    }
    
    return (
        <div>
            {visible && (
                <>
                    <UitkSpacing margin={{blockend: "four"}}>
                        <UitkTextArea
                            id={`faq-feedback-survey`}
                            label={faqFeedbackLabel}
                            placeholder={faqFeedbackPlaceholder}
                            name='textareaValue'
                            onChange={(e) => setMessage(e.target.value)}
                            className="uitk-field-textarea"
                            maxLength={255}
                        />
                    </UitkSpacing>
                    <UitkPrimaryButton
                        name='faq-feedback-send'
                        type='button'
                        onClick={handleSubmit}>
                        {faqFeedbackSendButton}
                    </UitkPrimaryButton>
                </>
            )}
        </div>
    )
}